import { Injectable } from '@angular/core';
import { ReservationType } from '../payment';
import { TrackingClient } from './tracking-client.interface';

@Injectable()
export class TrackingService {
  private clients: TrackingClient[] = [];

  addClient(client: TrackingClient) {
    this.clients.push(client);
  }

  async pageView(page: string) {
    this.clients.map(async (client) => {
      await client.pageView?.(page);
    });
  }

  async addToCart(category: string, entityType: string, name: string, count: number) {
    this.clients.map(async (client) => {
      await client.addToCart?.(category, entityType, name, count);
    });
  }

  async removeFromCart(category: string, entityType: string, name: string, count: number) {
    this.clients.map(async (client) => {
      await client.removeFromCart?.(category, entityType, name, count);
    });
  }

  async revenue(reservation: ReservationType) {
    await Promise.all(
      this.clients.map(async (client) => {
        await client.revenue?.(reservation);
      }),
    );
  }
}
